export default __webpack_public_path__ + "static/media/hard-drive.39994dfd.svg";